export default __webpack_public_path__ + "static/media/LexendDeca-SemiBold.0b733ed6.ttf";